import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function AccountReport() {
    const [customers, setCustomers] = useState([]);
    const [suppliers, setSuppliers] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const [custRes, suppRes] = await Promise.all([
                axios.get(`${getApiUrl()}/customers`),
                axios.get(`${getApiUrl()}/suppliers`)
            ]);
            
            const custWithBal = await Promise.all(custRes.data.map(async c => {
                const bal = await axios.get(`${getApiUrl()}/customers/${c.id}/balance`);
                return { ...c, balance: bal.data.balance };
            }));
            const suppWithBal = await Promise.all(suppRes.data.map(async s => {
                const bal = await axios.get(`${getApiUrl()}/suppliers/${s.id}/balance`);
                return { ...s, balance: bal.data.balance };
            }));

            setCustomers(custWithBal);
            setSuppliers(suppWithBal);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Account Report (Ledger)</h2>
                
                <div className="row mt-4">
                    <div className="col-md-6">
                        <h4>Customer Balances</h4>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Customer Name</th>
                                        <th>Current Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {customers.map(c => (
                                        <tr key={c.id}>
                                            <td>{c.name}</td>
                                            <td className={`fw-bold ${c.balance > 0 ? 'text-danger' : 'text-success'}`}>
                                                ₹ {parseFloat(c.balance || 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                    {customers.length === 0 && <tr><td colSpan="2" className="text-center">No customers found</td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <h4>Supplier Balances</h4>
                        <div className="table-responsive">
                            <table className="table table-bordered table-hover">
                                <thead className="table-dark">
                                    <tr>
                                        <th>Supplier Name</th>
                                        <th>Current Balance</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {suppliers.map(s => (
                                        <tr key={s.id}>
                                            <td>{s.name}</td>
                                            <td className={`fw-bold ${s.balance > 0 ? 'text-danger' : 'text-success'}`}>
                                                ₹ {parseFloat(s.balance || 0).toFixed(2)}
                                            </td>
                                        </tr>
                                    ))}
                                    {suppliers.length === 0 && <tr><td colSpan="2" className="text-center">No suppliers found</td></tr>}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Layout>
    );
}

export default AccountReport;
